import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-normal text-primary ml-4 fs-16 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }),
  /*#__PURE__*/_createTextVNode("  Back ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold ml-4 fs-16 cursor-pointer" }, "Ticket", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "Created fs-14" }
const _hoisted_6 = { style: {"min-height":"80px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Open ")
const _hoisted_8 = { hidden: "" }
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("   Close ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_TicketDetailDialog = _resolveComponent("TicketDetailDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_button, {
                type: "primary",
                link: "",
                onClick: _ctx.onClose
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"]),
              _hoisted_3
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = false)),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_table, {
              data: _ctx.tickets,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  property: "subject",
                  label: "",
                  class: "cursor-pointer"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("a", {
                      class: "Subject font-bold text-primary",
                      onClick: ($event: any) => (_ctx.onViewDetailTicket(scope.row._id))
                    }, _toDisplayString(scope.row.subject), 9, _hoisted_4),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatTime(scope.row.created_date)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  fixed: "right",
                  label: "",
                  width: "120",
                  style: {"text-align":"right"}
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_tag, {
                        type: "info",
                        class: "mx-1",
                        effect: "dark",
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createElementVNode("span", _hoisted_8, _toDisplayString(scope.$index), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]), [
              [_directive_loading, _ctx.isLoading]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TicketDetailDialog, { ref: "ticketDetaiDialog" }, null, 512)
  ], 64))
}